












































import { Component, Vue, Ref } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import MediumAudience from "@/models/MediumAudience";
import WithErrors from "@/directives/WithErrors";

@Component({ components: { VModal }, directives: { WithErrors } })
export default class MediumModal extends Vue {
  @Ref() readonly modal!: VModal;

  item: MediumAudience = new MediumAudience();

  title = "Nuovo media audience";
  tag = "";

  open(value: MediumAudience | null, tag: string) {
    this.modal.show();
    this.title = "Modifica audience";
    this.item = Object.assign({}, value);
    this.tag = tag;
  }

  close() {
    this.modal.hide();
  }

  onSave() {
    this.$emit("input", this.item);
  }

  onCancel() {
    this.close();
  }
}
